import React from 'react';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function Approach() {
    const imgStyle = {
        maxWidth: '100%',
        maxHeight: '100%',
        objectFit: 'contain',
        display: 'block',
        margin: '0 auto',
        borderRadius: '8px',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)' // Thêm tí shadow nhìn cho chuyên nghiệp
    };
    return (
        <Container maxWidth="md" sx={{ my: 4 }}>
            <Stack direction={{ xs: 'column', md: 'row' }} spacing={4}>
                <Stack>
                    <Typography variant="h6" component="h2" sx={{ fontWeight: 600, textAlign: { xs: 'left', md: 'right' } }}>
                        APPROACH
                    </Typography>
                </Stack>
                <Stack>
                    <Typography variant="body1" sx={{ textAlign: 'justify' }}>
                        We propose SEEME, a framework that automates the imaginative interpretation of natural 
                        object silhouettes by integrating retrieval-based strategies with generative models. 
                        Our pipeline explores two complementary strategies: 
                        (1) <strong>Visual-RAG</strong>: employs shape context-based contour matching and RANSAC alignment 
                        to retrieve structurally compatible exemplars, utilizing an IP-Adapter to transfer visual appearance 
                        while maintaining silhouette boundaries. 
                        (2) <strong>Semantic-RAG</strong>: decomposes the silhouette geometry into an interpretable 
                        "shape blueprint" using convexity defect analysis, infers classes via a multi-candidate weighted voting scheme, 
                        and guides a controlled SDXL inpainting model via detailed LLM-synthesized prompts.
                    </Typography>
                </Stack>
            </Stack>
            
            {/* Mục hiển thị hình ảnh Sơ đồ Pipeline */}
            <Box sx={{ pt: 6 }}>
                <img src='/figures/abstract_approach.png' style={imgStyle} alt="Overview of the SEEME framework architecture"/>
            </Box>
        </Container>
    );
};
export default Approach;